
import { CalculatorCategory } from '@/lib/types/calculator.types';

export const lifestyleCategory: CalculatorCategory = {
  id: 'lifestyle',
  name: 'Lifestyle & Fun',
  description: 'Practical calculators for everyday life scenarios, events, and planning',
  theme: 'lifestyle',
  icon: 'calendar',
  calculators: [
    {
      id: 'age',
      name: 'Age Calculator',
      description: 'Find your exact age in years, months, and days',
      theme: 'lifestyle'
    },
    {
      id: 'date',
      name: 'Date Calculator',
      description: 'Calculate days between dates or add/subtract time from a date',
      theme: 'lifestyle'
    },
    {
      id: 'time-between',
      name: 'Time Between Dates',
      description: 'Calculate the exact time between any two dates',
      theme: 'lifestyle'
    },
    {
      id: 'life-expectancy',
      name: 'Life Expectancy',
      description: 'Estimate your life expectancy based on health and lifestyle factors',
      theme: 'lifestyle'
    },
    {
      id: 'compatibility',
      name: 'Compatibility',
      description: 'Calculate compatibility between names or birthdates',
      theme: 'lifestyle'
    },
    {
      id: 'lucky-number',
      name: 'Lucky Number',
      description: 'Generate your lucky number based on personal details',
      theme: 'lifestyle'
    },
    {
      id: 'character-quiz',
      name: 'Character Quiz',
      description: 'Find out which character you are from popular media',
      theme: 'lifestyle'
    },
    {
      id: 'psychological',
      name: 'Psychological Test',
      description: 'Discover insights about your personality and thinking',
      theme: 'lifestyle'
    },
    {
      id: 'travel-budget',
      name: 'Travel Budget',
      description: 'Plan your travel expenses and stay within budget',
      theme: 'lifestyle'
    },
    {
      id: 'gift-budget',
      name: 'Gift Budget',
      description: 'Manage your gift expenses for holidays and events',
      theme: 'lifestyle'
    },
    {
      id: 'pet-food',
      name: 'Pet Food Calculator',
      description: 'Calculate the recommended food amount for your dog or cat',
      theme: 'lifestyle'
    }
  ]
};

export default lifestyleCategory;
